import React, { Component } from "react";
import _ from "lodash";
import { FormControlLabel, Button,  Checkbox, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DropZone from "./dropZone";

class DefaultDayPanel extends Component { 
    constructor(props) {
      super(props);
      this.state = {
        idx: props.idx,
        day: props.day,
        showDay: props.showDay,
        fromInput: props.fromInput,
        toInput: props.toInput,
        openConfirmation: false,
        confirmed: false,
        tempData : [],
      }
    } 

    handleOpeningHoursDroppedData = (d) => {
      this.props.droppedData(d);
    } 

    handleConfirmation = (checked, idx) => {
      if( this.state.confirmed === true ){
        this.setState({ openConfirmation: false, showDay: false }, function(){
          // if checkbox is confirmed `unchecked`
          this.props.setOpen(checked, idx);

          // reset
          this.setState({ confirmed: false, tempData: [] });
        })
      }else{
        this.setState({ showDay: true }, function(){
          this.props.setOpen(checked, idx);
        });
      }
      //this.props.setOpen(checked, this.state.idx)
    }

    render() {
      return (
        <>
          <Accordion> 
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls="additional-actions-content"
              id="additional-actions-header"
            >
              <FormControlLabel
                aria-label={this.state.day} 
                onClick={(event) => event.stopPropagation()}
                onFocus={event => event.stopPropagation()}
                control={<Checkbox checked={this.state.showDay} onChange={(e, checked) => {
                  if( this.state.showDay === false ){
                    this.handleConfirmation(checked, this.state.idx);
                  }else{
                    this.setState({ openConfirmation: true, tempData: [checked, this.state.idx] }) 
                  }
                }}
                  color="primary" />}
                label={this.state.day}
              />
            </AccordionSummary>

            { 
              this.state.showDay === true && this.props.data.is24Hours === false && 
              <DropZone 
                targetKey={this.state.day} 
                idx={this.state.idx} 
                fromInputKey={ this.state.fromInput } 
                toInputKey={ this.state.toInput } 
                dropToDayData={(e) => { this.handleOpeningHoursDroppedData(e) }}  /> 
            }

            <AccordionDetails>
              <Typography />
              {this.props.onShowForm(this.state.idx, this.state.fromInput, this.state.toInput)}
            </AccordionDetails>
          </Accordion>

          <Dialog fullWidth={true} open={this.state.openConfirmation}  onClose={() => { this.setState({ openConfirmation: false }) }} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Are you sure?</DialogTitle>
          <DialogContent>
            All the current timings below on this day scheduled will be removed.
          </DialogContent>
          <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}>
            <Button color="primary" variant="contained" style={{ cursor: "pointer" }} onClick={() => { this.setState({ confirmed: true }, () => { this.handleConfirmation( this.state.tempData[0], this.state.tempData[1] ) }) }}>Update</Button>
            <Button color="secondary" variant="contained" onClick={() => { this.setState({ openConfirmation: false, confirmed: false }) }} >Cancel</Button>
          </DialogActions>
          </Dialog> 
        </>
      ) 
    }
}

export default DefaultDayPanel;